var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"one-data-column"},[_c('div',_vm._b({staticClass:"one-data-column__column one-data-column__label-column"},'div',_vm.labelProps,false),[_vm._t("label")],2),_vm._v(" "),_c('div',_vm._b({staticClass:"one-data-column__column one-data-column__data-column"},'div',_vm.dataProps,false),[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }